var toneEmojiShortName = ':raised_hand:';
var byShortName = function byShortName(emojis, shortName) {
  return emojis.filter(function (emoji) {
    return emoji.shortName === shortName;
  })[0];
};
var toneEmoji = function toneEmoji(emojis) {
  return byShortName(emojis, toneEmojiShortName);
};
export var getToneEmoji = function getToneEmoji(provider) {
  return provider.findByShortName(toneEmojiShortName);
};
export default {
  byShortName: byShortName,
  toneEmoji: toneEmoji
};